// Avatar-generation socket payload, emitted on the shared `'event'` channel and
// routed by `type: 'ai-avatar'`. On FINISHED, `mediaItems` carries the generated
// video samples as full media items.

import { IMediaItem } from 'types/media'

export enum AIAvatarSocketMessageState {
  PREPARING_AI_VIDEO = 'preparing_ai_video',
  // Mid-render: the voiceover (TTS) has been produced, which is when a free
  // user's gift/credit is actually consumed. Triggers a gift-access re-check so
  // the generate footer reflects the new balance before the full video FINISHES.
  VOICEOVER_GENERATED = 'voiceover_generated',
  FINISHED = 'finished',
  ERROR = 'error'
}

// One generated voiceover (TTS) part = one avatar SCREEN. The backend renders a
// separate sub-video per screen, so the array length is the real screen count and
// each `duration` is that screen's video length in seconds. Present on
// VOICEOVER_GENERATED; drives the render-phase progress estimate (see
// `estimateAvatarRenderSecondsFromScreens`). Only `duration` is consumed here.
export interface IAIAvatarVoiceoverPart {
  id: number
  duration: number
  filePath: string
  text: string
}

export interface IAIAvatarSocketMessage {
  ai_avatar_project_id: number
  ai_avatar_video_hash: string
  state: AIAvatarSocketMessageState
  type: 'ai-avatar'
  user_id: number

  aiAvatarProjectId?: number
  mediaItems: IMediaItem[]

  // Present on VOICEOVER_GENERATED: the real per-screen voiceover parts, used to
  // re-estimate the render phase from actual durations instead of the text-based
  // approximation made at generation start.
  voiceoverData?: IAIAvatarVoiceoverPart[]

  // Present on ERROR: backend-supplied human-readable reason (e.g. "No AI
  // credits available."). When set, the failure handler surfaces it verbatim
  // (CUSTOM_API_ERROR) instead of the generic copy.
  message?: string
}
